import { localeNumberWithFixed } from "psims/lib/formatters/numbers";
import { ACCValidationResult } from "./aus-control-corps-validations";

export function getACCInlineMessage(
  validationResult: ACCValidationResult | null,
): string | undefined {
  if (validationResult == null) {
    return undefined;
  }

  switch (validationResult.code) {
    case 'invalid_required':
      return 'A value is required for this field';
    case 'character_limit':
      return `Must be ${localeNumberWithFixed(validationResult.limit)} characters or fewer`;
    case 'invalid_characters':
      return 'Must only contain letters, numbers, hyphens, apostrophes, and parentheses';
    case 'invalid_length':
      return `Must be exactly ${validationResult.requiredLength} characters`;
    case 'invalid_abn_acn_format':
      return `Must be exactly ${validationResult.requiredLength} digits, without letters, space or special characters`;
    case 'numeric_only':
      return 'Must contain numbers only';
    case 'abn_or_acn_required':
      return 'Either an ABN or ACN must be provided.';
  }
}